import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/registry_analytics_event.py
export const REGISTRY_ANALYTICS_ACTIONS = {
  // READ actions
  FILE_LINKED_TO_REGISTERED_FILE: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'field_linked_to_registered_file',
    actionCategory: ACTION_CATEGORY.READ,
  },
  FILE_LINKED_TO_UNREGISTERED_FILE: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'field_linked_to_unregistered_file',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ENTRY_LINKED_TO_BATCH: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'entry_linked_to_batch',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ENTRY_LINKED_TO_FILE: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'entry_linked_to_registered_file',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_BATCH: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'opened_batch',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_REGISTERED_FILE: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'opened_registered_file',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SEARCHED_FILES: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'searched_registered_files',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // WRITE actions
  ARCHIVED_BATCHES: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'archived_batches',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COPIED_FILES: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'copied_registered_file',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_BATCHES: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'created_batches',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_FILES_IN_REGISTRY_MODAL: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'created_files_in_registry_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REGISTERED_FILES: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'register_files',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SUBMITTED_BIOENTITY_SPREADSHEET_IMPORT_MODAL: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'submitted_bioentity_spreadsheet_import_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SUBMITTED_AUTOFILL_SEQUENCE_FEATURE: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'submitted_autofill_sequence_feature',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  AUTOFILL_ACTION_COMPLETED: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'successfully_autofilled_sequence_feature',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_BATCHES: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'updated_batches',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_FILES: {
    module: ANALYTICS_MODULE.REGISTRY,
    action: 'updated_registered_files',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
